// Vorher/Nachher-Schieberegler
function initBASliders() {
  document.querySelectorAll('.ba-slider').forEach(function (slider) {
    var after = slider.querySelector('.ba-after');
    var handle = slider.querySelector('.ba-handle');
    if (!after || !handle) return;

    function setPos(percent) {
      percent = Math.max(0, Math.min(100, percent));
      after.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
      handle.style.left = percent + '%';
    }

    function posFromEvent(e) {
      var rect = slider.getBoundingClientRect();
      var clientX = (e.touches && e.touches.length) ? e.touches[0].clientX : e.clientX;
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    var dragging = false;

    function start(e) {
      dragging = true;
      move(e);
      e.preventDefault();
    }
    function move(e) {
      if (!dragging) return;
      setPos(posFromEvent(e));
    }
    function end() {
      dragging = false;
    }

    slider.addEventListener('mousedown', start);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', end);

    slider.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', end);

    setPos(50);
  });
}

document.addEventListener('DOMContentLoaded', initBASliders);
